import { render, staticRenderFns } from "./ReportPolice.vue?vue&type=template&id=753c3e78&scoped=true&"
import script from "./ReportPolice.vue?vue&type=script&lang=ts&"
export * from "./ReportPolice.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPolice.vue?vue&type=style&index=0&id=753c3e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c3e78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VForm,VRadio,VRadioGroup,VTextField})
